// Anything exported from this file is importable by other in-browser modules.
import i18n from "./i18n/config";
export default i18n;
